
import {throwError as observableThrowError,  Observable, Subscription } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { routes } from "environments/environment";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class AppCodeConfirmService {
  constructor(private http: HttpClient) {}

  senKey(dados): Observable<any> {
    return this.http.post(routes.send_key_2_factor, dados);
  }

  validateKey(dados): Observable<any> {
    return this.http.patch(routes.validate_key_2_factor, dados);
  }

  getContacts(codeCobra, keyApp, keyUserCompany): Observable<any> {
    try {
      return this.http
        .get(
          `${routes.get_contacts}?codecobra=${codeCobra}&typephone=C&typestatusphone=A&statusemail=A&keyApp=${keyApp}&keyUserCompany=${keyUserCompany}`
        )
        .pipe(
          map((res: any) => {
            try {
              return res.data;
            } catch (error) {
              throw res;
            }
          }),
          catchError((error) => {
            return observableThrowError(error);
          })
        );
    } catch (error) {
      return observableThrowError(error);
    }
  }
}
